import {
  Card,
  CardContent,
  CardHeader,
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
  Toolbar,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Collapse from "@material-ui/core/Collapse";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Step from "@material-ui/core/Step";
import StepContent from "@material-ui/core/StepContent";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";

import datetimeHelper from "./../../helper/datetime-helper";
import { globalHistory } from "./../../history";
import { mapActionsToProps as agentConnect } from "./../../redux/agent";
import { mapActionsToProps } from "./../../redux/campaigns";
import { mapActionsToProps as phoneNumberAction } from "./../../redux/cloudPBX/phoneNumber";
import { mapActionsToProps as contactFile } from "./../../redux/miniCrm/contact";
import { mapActionsToProps as stageAction } from "./../../redux/miniCrm/stage";
import { mapActionsToProps as formAction } from "./../../redux/telesale/form";

const city = [
  { id: "01", name: "Hà Nội" },
  { id: "02", name: "Hà Giang" },
  { id: "04", name: "Cao Bằng" },
  { id: "06", name: "Bắc Kạn" },
  { id: "08", name: "Tuyên Quang" },
  { id: "10", name: "Lào Cai" },
  { id: "11", name: "Điện Biên" },
  { id: "12", name: "Lai Châu" },
  { id: "14", name: "Sơn La" },
  { id: "15", name: "Yên Bái" },
  { id: "17", name: "Hoà Bình" },
  { id: "19", name: "Thái Nguyên" },
  { id: "20", name: "Lạng Sơn" },
  { id: "22", name: "Quảng Ninh" },
  { id: "24", name: "Bắc Giang" },
  { id: "25", name: "Phú Thọ" },
  { id: "26", name: "Vĩnh Phúc" },
  { id: "27", name: "Bắc Ninh" },
  { id: "30", name: "Hải Dương" },
  { id: "31", name: "Hải Phòng" },
  { id: "33", name: "Hưng Yên" },
  { id: "34", name: "Thái Bình" },
  { id: "35", name: "Hà Nam" },
  { id: "36", name: "Nam Định" },
  { id: "37", name: "Ninh Bình" },
  { id: "38", name: "Thanh Hoá" },
  { id: "40", name: "Nghệ An" },
  { id: "42", name: "Hà Tĩnh" },
  { id: "44", name: "Quảng Bình" },
  { id: "45", name: "Quảng Trị" },
  { id: "46", name: "Thừa Thiên Huế" },
  { id: "48", name: "Đà Nẵng" },
  { id: "49", name: "Quảng Nam" },
  { id: "51", name: "Quảng Ngãi" },
  { id: "52", name: "Bình Định" },
  { id: "54", name: "Phú Yên" },
  { id: "56", name: "Khánh Hoà" },
  { id: "58", name: "Ninh Thuận" },
  { id: "60", name: "Bình Thuận" },
  { id: "62", name: "Kon Tum" },
  { id: "64", name: "Gia Lai" },
  { id: "66", name: "Đắk Lắk" },
  { id: "67", name: "Đắk Nông" },
  { id: "68", name: "Lâm Đồng" },
  { id: "70", name: "Bình Phước" },
  { id: "72", name: "Tây Ninh" },
  { id: "74", name: "Bình Dương" },
  { id: "75", name: "Đồng Nai" },
  { id: "77", name: "Bà Rịa - Vũng Tàu" },
  { id: "79", name: "Hồ Chí Minh" },
  { id: "80", name: "Long An" },
  { id: "82", name: "Tiền Giang" },
  { id: "83", name: "Bến Tre" },
  { id: "84", name: "Trà Vinh" },
  { id: "86", name: "Vĩnh Long" },
  { id: "87", name: "Đồng Tháp" },
  { id: "89", name: "An Giang" },
  { id: "91", name: "Kiên Giang" },
  { id: "92", name: "Cần Thơ" },
  { id: "93", name: "Hậu Giang" },
  { id: "94", name: "Sóc Trăng" },
  { id: "95", name: "Bạc Liêu" },
  { id: "96", name: "Cà Mau" },
];

function TabContainer(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const styles = (theme) => ({
  input: {
    width: "98%",
    marginTop: theme.spacing.unit * 3,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  button: {
    margin: theme.spacing.unit * 3,
  },
  resetContainer: {
    padding: theme.spacing.unit * 3,
  },
  select: {
    width: "98%",
    margin: theme.spacing.unit * 3,
  },
  grid: {
    width: "100%",
    paddingLeft: theme.spacing.unit * 3,
    paddingRight: theme.spacing.unit * 3,
  },
  actions: {
    display: "flex",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  card: {
    marginBottom: theme.spacing.unit * 3,
  },
  formControl: {
    width: "100%",
  },
  root: {
    width: "100%",
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
    borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
  },
});
function getSteps() {
  return ["Chọn đầu số điện thoại gọi ra", "Dữ liệu danh bạ", "Mẫu kịch bản"];
}

class CampaignConfig extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.getInitState();
  }

  getInitState() {
    return {
      value: "file",
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      name: "",
      note: "",
      startAt: "",
      endAt: "",
      contactInCampaign: false,
      activeStep: 0,
      radioForm: 0,
      expanded: false,
      number: 0,
      dataAgent: [],
      dataAgentNew: {
        ...this.props.listAgents,
      },
      dataCount: [],
      formId: "",
      calls: 0,
      agent: {},
      ItemAgent: [],
      stage: [],
      checkSelect: true,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();

    this.unlisten = this.history.listen(() => {
      this.getDetail();
    });
    await this.getDetail();
  }
  getDetail() {
    const id = this.props.match.params.id;
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "city":
            case "toage":
            case "fromage":
            case "gender":
            default: {
              where[key] = element;
              break;
            }
          }
        }
      }
    }
    this.props.getACampaignDetail(id);
    this.props.getListContactFile();
    this.props.getListContacts(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.getListForm(null, null, null, { where: { campaignId: id } });
    this.props.getListGroupAgent();
    this.props.getListPhoneNumber();
    this.props.getListStage();
  }

  componentWillUnmount() {
    this.unlisten();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.campaign != this.props.campaign) {
      const { id, name, note, startAt, endAt } = this.props.campaign;
      this.setState({
        id,
        name,
        note,
        startAt,
        endAt,
      });
    }
  }

  handleChangeNumber = (name, value, key, item) => {
    this.state.dataAgent.map((item, i) => {
      if (i === key) {
        this.setState({
          ...item,
          [name]: value,
        });
      }
    });
  };

  renderAge = () => {
    let age = [];
    for (let i = 0; i <= 100; i++) {
      age.push(
        <MenuItem key={i} value={i}>
          {i}
        </MenuItem>
      );
    }
    return age;
  };

  listCollumns = [
    { id: "count", numeric: true, disablePadding: false, label: "Tổng" },
    // { id: "vina", numeric: true, disablePadding: false, label: "Vinaphone" },
    // { id: "mobi", numeric: true, disablePadding: false, label: "Mobiphone" },
    // { id: "viettel", numeric: true, disablePadding: false, label: "Viettel" },
    // { id: "vnm", numeric: true, disablePadding: false, label: "Vietnammobile" },
    // { id: "gtel", numeric: true, disablePadding: false, label: "Gtel" }
  ];

  listRows = [
    { id: "code", numeric: false, disablePadding: false, label: "Mã ĐTV" },
    { id: "user", numeric: false, disablePadding: false, label: "Tên ĐTV" },
    { id: "group", numeric: false, disablePadding: false, label: "Nhóm" },
  ];

  listRows2 = [
    { id: "code", numeric: false, disablePadding: false, label: "Mã ĐTV" },
    { id: "user", numeric: false, disablePadding: false, label: "Tên ĐTV" },
    { id: "group", numeric: false, disablePadding: false, label: "Nhóm" },
    {
      id: "number",
      numeric: false,
      disablePadding: false,
      label: "Số cuộc gọi",
    },
  ];

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };

  handleSubmitSearch = () => {
    this.props.countListContacts({ where: this.state.filters.where });
    let count = {};
    if (this.props.count) {
      return (
        this.state.dataCount.push({ id: 0, count: this.props.count.count }),
        (count = Array.from(
          new Set(this.state.dataCount.map(JSON.stringify))
        ).map(JSON.parse)),
        this.setState({
          dataCount: count,
          countNumbers: this.props.count.count,
        })
      );
    }
  };

  handleChangeTab = (event, value) => {
    this.setState({ value });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState(
        {
          [name]: e.target.value,
          checkSelect: false,
        },
        () => {
          const { listContactFile } = this.props;
          const listContactFileResult =
            typeof listContactFile === "object"
              ? Object.keys(listContactFile).map((key) => listContactFile[key])
              : listContactFile;
          const data = listContactFileResult.find(
            (i) => i.id === this.state.contactFile
          );
          let count = {};
          if (data) {
            if (this.state.dataCount) {
              return this.state.dataCount.map((i) => {
                if (i.id == 0) {
                  this.state.dataAgent.pop();
                }
              });
            }
            return (
              this.state.dataCount.push({
                id: 1,
                count: data.phoneNumbers.length,
              }),
              (count = Array.from(
                new Set(this.state.dataCount.map(JSON.stringify))
              ).map(JSON.parse)),
              this.setState({
                dataCount: count,
                value: "file",
                countNumbers: data.phoneNumbers.length,
              })
            );
          }
        }
      );
    };
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleSubmit = () => {
    // const { filters: { where }, formId, dataAgent, ItemAgent } = this.state;
    const {
      contactFileId,
      type,
      from,
      stage,
      formId,
      dataStage,
      value,
      filters,
    } = this.state;
    const { listStage } = this.props;
    const id = this.props.match.params.id;
    const dataStageResult =
      typeof dataStage === "object"
        ? Object.keys(dataStage).map((key) => dataStage[key])
        : dataStage;
    if (dataStageResult) {
      dataStageResult.map((i, key) => {
        return this.state.stage.push(i);
      });
    }
    // const agent = Array.from(new Set(dataAgent.map(JSON.stringify))).map(JSON.parse);
    // this.props.campaignConfig(id, { contact: { where, source: this.state.value, contactFileId: this.state.contactFile } }, { agents: agent }, formId)
    this.props.campaignConfig(
      id,
      contactFileId,
      "auto-call",
      from,
      stage,
      formId,
      value,
      filters.where
    );
  };

  handleChangeRadio = (value, key) => {
    this.setState({ radioForm: key, formId: value, checkSelect: false });
  };

  handleChangeRadioStep1 = (event) => {
    this.setState({ value: event.target.value });
  };

  handleChangeCheckbox = (name) => (event) => {
    this.setState({
      [name]: event.target.checked,
    });
  };

  handleCheckStage = (name) => (event) => {
    if (event.target.checked === true) {
      this.setState({
        dataStage: {
          ...this.state.dataStage,
          [name]: event.target.value,
        },
      });
    } else {
      delete this.state.dataStage[name];
    }
  };
  handleNext = () => {
    this.setState((state) => ({
      activeStep: state.activeStep + 1,
      checkSelect: true,
    }));
  };

  handleBack = () => {
    this.setState((state) => ({
      activeStep: state.activeStep - 1,
    }));
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };

  handleAddData = (e, item) => {
    const { dataAgent, dataAgentNew } = this.state;
    dataAgent.push(item);
    const listdataAgentResult =
      typeof dataAgent === "object"
        ? Object.keys(dataAgent).map((key) => dataAgent[key])
        : dataAgent;
    const agent = Array.from(
      new Set(listdataAgentResult.map(JSON.stringify))
    ).map(JSON.parse);
    this.setState({ dataAgent: agent });
  };

  handleDropData = (e, item) => {
    const { dataAgent } = this.state;
    dataAgent.pop(item);
    const listdataAgentResult =
      typeof dataAgent === "object"
        ? Object.keys(dataAgent).map((key) => dataAgent[key])
        : dataAgent;
    this.setState({ dataAgent: listdataAgentResult });
  };

  handleShare = () => {
    const { dataAgent, calls } = this.state;
    const c = this.state.dataCount.find((i) => i.id == 1);
    const count = c.count;
    // const count = this.props.count.count
    this.setState({ ct: count });
    const length = this.state.dataAgent.length;
    const numSurplus = count % length;
    let agent = [];
    if (numSurplus === 0) {
      const number = count / length;
      dataAgent.map((item) => {
        return agent.push({ id: item.id, calls: number });
      });
      this.setState({ calls: number, agent: agent });
    } else {
      const newLastElement = [];
      const number = (count - numSurplus) / length;
      this.setState({ calls: number });
      dataAgent.map((item) => {
        agent.push({ id: item.id, calls: number });
      });
      const last_element = agent[agent.length - 1];
      agent.map((item) => {
        if (item.id === last_element.id) {
          return (
            agent.pop(item),
            newLastElement.push({ id: last_element.id, calls: number + 1 })
          );
        }
      });

      const newAgent = agent.concat(newLastElement);
      const newCalls = newAgent.find((item) => item.id === last_element.id);
      this.setState({ agent: newAgent });
    }
  };

  handleRefreshShare = () => {
    const { agent } = this.state;
    let agentRefresh = [];
    agent.map((item) => {
      return agentRefresh.push({ calls: 0, id: item.id });
    });
    this.setState({ calls: 0, agent: agentRefresh });
  };

  handleContactFile = () => {
    const { listContactFile } = this.props;
    const listContactFileResult =
      typeof listContactFile === "object"
        ? Object.keys(listContactFile).map((key) => listContactFile[key])
        : listContactFile;
    const data = listContactFileResult.find(
      (i) => i.id === this.state.contactFile
    );
    let count = {};
    if (data) {
      return (
        this.state.dataCount.push({ id: 1, count: data.contacts.length }),
        (count = Array.from(
          new Set(this.state.dataCount.map(JSON.stringify))
        ).map(JSON.parse)),
        this.setState({
          dataCount: count,
          value: "file",
          countNumbers: data.contacts.length,
        })
      );
    }
  };

  handleSelectedItem = (item) => {
    this.state.ItemAgent = item;
  };

  handleSearchCount = () => {
    if (this.state.value == "file") {
      const { dataStage, contactFileId } = this.state;
      const dataStageResult =
        typeof dataStage === "object"
          ? Object.keys(dataStage).map((key) => dataStage[key])
          : dataStage;
      const { listContactFile } = this.props;
      const listContactFileResult =
        typeof listContactFile === "object"
          ? Object.keys(listContactFile).map((key) => listContactFile[key])
          : listContactFile;
      const data = listContactFileResult.find(
        (i) => i.id === this.state.contactFileId
      );
      let dataStateId = [];
      if (dataStageResult) {
        dataStageResult.map((i, key) => {
          return (
            this.state.stage.push(i),
            (dataStateId = Array.from(
              new Set(this.state.stage.map(JSON.stringify))
            ).map(JSON.parse))
          );
        });
      }
      this.setState({ dataContact: data });
      this.props.countContactFile(contactFileId, dataStateId);
    } else {
      this.setState({ checkSelect: false });
    }
  };

  getStepContent = (step) => {
    const { phoneNumberId, filters } = this.state;
    const {
      classes,
      listContactFile,
      listFormTelesale,
      listAgentGroups,
      listPhoneNumber,
      listStage,
    } = this.props;
    const listContactFileResult =
      typeof listContactFile === "object"
        ? Object.keys(listContactFile).map((key) => listContactFile[key])
        : listContactFile;
    const listFormTelesaleResult =
      typeof listFormTelesale === "object"
        ? Object.keys(listFormTelesale).map((key) => listFormTelesale[key])
        : listFormTelesale;
    const listStageResult =
      typeof listStage === "object"
        ? Object.keys(listStage).map((key) => listStage[key])
        : listStage;
    const listPhoneNumberResult =
      typeof listPhoneNumber === "object"
        ? Object.keys(listPhoneNumber).map((key) => listPhoneNumber[key])
        : listPhoneNumber;
    switch (step) {
      case 0:
        return (
          <Grid container>
            <Grid item md={12}>
              <TextField
                id="outlined-select-currency"
                select
                label="Chọn số điện thoại"
                className={classes.select}
                value={this.state.from}
                onChange={this.handleChangeText("from")}
                name="from"
                // onClick={this.handleContactFile}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu,
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                margin="normal"
                variant="outlined">
                {listPhoneNumberResult
                  ? listPhoneNumberResult.map((item, key) => {
                      return (
                        <MenuItem key={key} value={item.id}>
                          {item.id}
                        </MenuItem>
                      );
                    })
                  : null}
              </TextField>
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <FormControl component="fieldset" className={classes.formControl}>
            <RadioGroup
              aria-label="data"
              name="value"
              className={classes.group}
              value={this.state.value}
              onChange={this.handleChangeRadioStep1}>
              <FormControlLabel
                value="data"
                control={
                  <Radio onClick={() => this.setState({ value: "data" })} />
                }
                label="Từ data danh bạ"
              />
              <FormControlLabel
                value="file"
                control={<Radio />}
                label="Từ file danh bạ"
              />
            </RadioGroup>
            {this.state.value == "data" ? (
              <ValidatorForm
                ref="form"
                onSubmit={this.handleSubmitSearch}
                onError={(errors) => console.log(errors)}
                className={classes.form}>
                <Grid container>
                  <Grid item md={6}>
                    <TextValidator
                      variant="outlined"
                      label="Giới hạn"
                      className={classes.select}
                      value={filters.where.limit}
                      onChange={this.handleSearch}
                      name="limit"
                      validators={[
                        "required",
                        "minNumber:1",
                        "maxNumber:10000",
                      ]}
                      errorMessages={[
                        `Không được để trống`,
                        "Số lớn hơn 1",
                        "Số nhỏ hơn 10000",
                      ]}
                    />
                    <SelectValidator
                      id="outlined-select-currency"
                      select
                      label="Độ tuổi từ"
                      className={classes.select}
                      value={filters.where.fromage}
                      onChange={this.handleSearch}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="normal"
                      variant="outlined"
                      name="fromage">
                      {this.renderAge()}
                    </SelectValidator>
                  </Grid>
                  <Grid item md={6}>
                    <SelectValidator
                      id="outlined-select-currency"
                      select
                      label="Giới tính"
                      className={classes.select}
                      value={filters.where.gender}
                      onChange={this.handleSearch}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="normal"
                      variant="outlined"
                      name="gender">
                      <MenuItem key="male" value="male">
                        Nam
                      </MenuItem>
                      <MenuItem key="female" value="female">
                        Nữ
                      </MenuItem>
                    </SelectValidator>

                    <SelectValidator
                      id="outlined-select-currency"
                      select
                      label="Độ tuổi đến"
                      className={classes.select}
                      value={filters.where.toage}
                      onChange={this.handleSearch}
                      SelectProps={{
                        MenuProps: {
                          className: classes.menu,
                        },
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      margin="normal"
                      variant="outlined"
                      name="toage"
                      validators={[`minNumber: ${filters.where.fromage}`]}
                      errorMessages={["Tuổi phải lớn hơn tuổi bắt đầu"]}>
                      {this.renderAge()}
                    </SelectValidator>
                  </Grid>
                </Grid>
              </ValidatorForm>
            ) : this.state.value == "file" ? (
              <Grid container>
                <Grid item md={12}>
                  <TextField
                    id="outlined-select-currency"
                    select
                    label="Contact file"
                    className={classes.select}
                    value={this.state.contactFileId}
                    onChange={this.handleChangeText("contactFileId")}
                    // onClick={this.handleContactFile}
                    name="contactFileId"
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    margin="normal"
                    variant="outlined">
                    {listContactFileResult
                      ? listContactFileResult.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {`${option.name} (${option.contacts.length} danh bạ)`}
                          </MenuItem>
                        ))
                      : null}
                  </TextField>
                </Grid>
                <FormGroup>
                  <Typography
                    component="h4"
                    variant="h6"
                    style={{ marginTop: 10 }}>
                    Trạng thái loại bỏ trong danh bạ:
                  </Typography>
                  <FormGroup>
                    {listStageResult
                      ? listStageResult.map((item, key) => {
                          return (
                            <FormControlLabel
                              key={key}
                              control={
                                <Checkbox
                                  onChange={this.handleCheckStage(key)}
                                  value={item.id}
                                  name={item.name}
                                />
                              }
                              label={item.name}
                            />
                          );
                        })
                      : null}
                  </FormGroup>
                </FormGroup>
                <Grid container>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.button}
                    type="submit"
                    onClick={this.handleSearchCount}>
                    Kiểm tra
                  </Button>
                </Grid>
                <Divider />
                <Typography
                  component="h4"
                  variant="h6"
                  style={{ marginTop: 10 }}>
                  Tổng số danh bạ sau lọc:{" "}
                  {this.props.countContact
                    ? this.props.countContact.count
                    : this.state.dataContact
                    ? this.state.dataContact.contacts.length
                    : ""}
                </Typography>
              </Grid>
            ) : null}
          </FormControl>
        );
      // case 2:
      //     return (
      //         <React.Fragment>
      //             <Typography component="h4" variant="h6" style={{ marginTop: 10 }}>
      //                 Tổng số cuộc gọi: {this.state.countNumbers}
      //             </Typography>
      //             <TableSelect
      //                 items={listAgentResult}
      //                 itemsRight={this.state.dataAgent}
      //                 handleSelect={this.handleSelectedItem}
      //             />
      //         </React.Fragment>
      //     );
      case 2:
        return (
          <FormControl component="fieldset" className={classes.formControl}>
            {listFormTelesaleResult
              ? listFormTelesaleResult.map((form, key) => {
                  return (
                    <React.Fragment key={key}>
                      <Card className={classes.card}>
                        <CardHeader
                          avatar={
                            <Radio
                              aria-label="data"
                              name="data"
                              className={classes.group}
                              // checked={this.state.radioForm === key}
                              value={form.id}
                            />
                          }
                          title={form.name}
                          onClick={(e) =>
                            this.handleChangeRadio(e.target.value, key)
                          }
                          action={
                            <IconButton
                              className={classnames(classes.expand, {
                                [classes.expandOpen]: this.state.radioForm,
                              })}
                              style={{ marginTop: 8 }}
                              aria-expanded={this.state.radioForm}
                              aria-label="Show more">
                              <ExpandMoreIcon />
                            </IconButton>
                          }
                        />
                        <Divider />
                        <Collapse
                          in={this.state.radioForm == key}
                          timeout="auto"
                          unmountOnExit>
                          <CardContent>
                            <Typography paragraph>{form.content}</Typography>
                          </CardContent>
                        </Collapse>
                      </Card>
                    </React.Fragment>
                  );
                })
              : null}
          </FormControl>
        );
      default:
        return "Unknown step";
    }
  };
  render() {
    const { startAt, endAt, filters, name, note, activeStep, checkSelect } =
      this.state;
    const { classes, campaign } = this.props;
    const steps = getSteps();
    return (
      <React.Fragment>
        <Paper className={classes.root}>
          <Toolbar className={classes.toolbar}>
            <span className={classes.breadCrumb}>
              <Button
                size="small"
                disableRipple={true}
                onClick={() =>
                  this.history.push(
                    `${process.env.REACT_APP_PATH}/mini-crm/campaign`
                  )
                }>
                <ArrowBackIos color="primary" />
                Danh sách chiến dịch
              </Button>
            </span>
            <div style={{ flexGrow: 1 }}></div>
          </Toolbar>

          <div
            style={{
              overflowX: "auto",
              justifyContent: "center",
              textAlign: "center",
            }}>
            <Typography component="h4" variant="h6" style={{ padding: 15 }}>
              Phân bổ chiến dịch: {name}
            </Typography>
            <Typography style={{ paddingBottom: 15, fontSize: 16 }}>
              Từ ngày: {datetimeHelper.toFormat(startAt, "YYYY-MM-DD")} đến
              ngày: {datetimeHelper.toFormat(endAt, "YYYY-MM-DD")}
            </Typography>
          </div>
        </Paper>
        <Paper square style={{ marginTop: 10 }}>
          <Stepper activeStep={activeStep} orientation="vertical">
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  {this.getStepContent(index)}
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={this.handleBack}
                        className={classes.button}
                        color="secondary"
                        variant="contained">
                        Quay lại
                      </Button>

                      {activeStep === steps.length - 1 ? (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleSubmit}
                          className={classes.button}
                          disabled={checkSelect}>
                          Hoàn tất thiết lập
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.handleNext}
                          className={classes.button}
                          disabled={checkSelect}>
                          Tiếp theo
                        </Button>
                      )}
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </Paper>
      </React.Fragment>
    );
  }
}

CampaignConfig.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listContactFile: state.contact.contactFiles,
  count: state.contact.count,
  countContact: state.contact.countContact,
  countConactFile: state.contact.countContactFile,
  listAgents: state.agent.agents,
  campaign: state.campaign.campaign,
  listFormTelesale: state.form.forms,
  listAgentGroups: state.agent.groupAgent,
  listPhoneNumber: state.phoneNumber.phoneNumbers,
  listStage: state.stage.stages,
});

const Agent = connect(mapStateToProps, agentConnect)(CampaignConfig);
const Campaign = connect(null, mapActionsToProps)(Agent);
const Form = connect(null, formAction)(Campaign);
const PhoneNumber = connect(null, phoneNumberAction)(Form);
const Stage = connect(null, stageAction)(PhoneNumber);
CampaignConfig = connect(null, contactFile)(Stage);

export default withStyles(styles)(CampaignConfig);
